import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Hero = () => {
  const data = useStaticQuery(graphql`
      query HeroQuery {
          allContentfulStart {
              edges {
                  node {
                      buttonLink
                      buttonText
                      title
                      id
                      image {
                        gatsbyImageData(width: 1080)
                      }
                  }
              }
          }
      }
  `)

  const Image = () => {
    if (!data?.allContentfulStart?.edges[0]?.node?.image?.gatsbyImageData) {
      return <div>Picture not found</div>
    }

    return (
      <GatsbyImage
        image={data.allContentfulStart.edges[0].node.image.gatsbyImageData} alt={""} />
    )
  }

  const heroData = data.allContentfulStart.edges[0].node || null

  const handleAnchorClick = (e, item) => {
    e.preventDefault()
    const elementId = item.link.replace("/#", "")

    const element = document.querySelector(`#${elementId}`)
    element && element.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <div id="start">
      <div className="section hero-section">
        <div className="hero-content">
          <h1 className="section-title">{heroData?.title}</h1>
          <p>{heroData?.content?.content}</p>
          <a className="button" href={heroData?.buttonLink} onClick={(e) => {
            handleAnchorClick(e, { link: heroData?.buttonLink })
          }}>{heroData?.buttonText}</a>
        </div>
        <div className="hero-image">
          <div>
            <Image />
          </div>
        </div>
      </div>
    </div>
  )
}

Hero.propTypes = {}

Hero.defaultProps = {}

export default Hero
